import type { BuildingGeometry } from "building-types/geometry/buildingGeometryTypes";
import type { ViewEntityTable } from "building-types/views/viewEntityTable";
import { ENTITY_ID_SEPARATOR, instanceIdForComponent } from "doc/entity/componentInstanceEntityResolve";

type ResolveBuildingGeometryEntityIdParams = {
  addEntityIdToFaceArrays: boolean;
  entityTable: ViewEntityTable | undefined;
  buildingGeometry: BuildingGeometry;
};

export function resolveBuildingGeometryEntityId({
  addEntityIdToFaceArrays,
  entityTable,
  buildingGeometry,
}: ResolveBuildingGeometryEntityIdParams): string | undefined {
  if (!addEntityIdToFaceArrays || !entityTable) {
    return undefined;
  }

  const { descriptor, entityId, viewEntityType, entityHandleForSelectingReportingUnit } = buildingGeometry;
  if (descriptor && "entityId" in descriptor) {
    const componentInstanceId =
      entityHandleForSelectingReportingUnit?.type === "COMPONENT_INSTANCE"
        ? entityHandleForSelectingReportingUnit.id
        : undefined;
    const resolvedEntityId =
      componentInstanceId && !descriptor.entityId.includes(ENTITY_ID_SEPARATOR)
        ? instanceIdForComponent(descriptor.entityId, [componentInstanceId])
        : descriptor.entityId;
    const descriptorForInsert =
      descriptor.entityId === resolvedEntityId ? descriptor : { ...descriptor, entityId: resolvedEntityId };
    return entityTable.insert(resolvedEntityId, descriptorForInsert);
  }

  if (entityId && descriptor) {
    // Keep legacy fallback for descriptors that do not carry entityId.
    return entityTable.insert(entityId, descriptor);
  }

  if (viewEntityType) {
    return entityTable.new(viewEntityType);
  }

  return undefined;
}
